// removed by extract-text-webpack-plugin
module.exports = {"binary_navigation_item":"_2hOH0AyefIRXMrV1MleALY","binary_navigation_nav":"_2nLguqdjcl-GnIVITRTcLz","binary_navigation_sub":"_6vxC1QYGDeS4Ht2zEyVKZ","binary_navigation_highlight":"_3ngrf9Bwh7ocp-oYnqloPA","binary_navigation_sub_highlight":"_20HOJb143V8UJIj0CNBOl-","binary_navigation_nav_noarrow":"_1PyI55Cda4goxPJEuJ2rl_","no_drop_down":"_1HXQDFLvx4100VnEiYnAKs"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryNavigationItem/BinaryNavigationItem.scss
// module id = 2300
// module chunks = 1